import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  inject,
} from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { TimelineModalFilterService } from '../../services/timeline-modal-filter.service';

@Component({
  selector: 'wilson-filter-qualified-working-time-staff-changed-button',
  imports: [TranslateModule, NzButtonModule],
  templateUrl:
    './filter-qualified-working-time-staff-changed-button.component.html',
  styleUrls: [
    './filter-qualified-working-time-staff-changed-button.component.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterQualifiedWorkingTimeStaffChangedButtonComponent {
  private readonly cdRef = inject(ChangeDetectorRef);
  timelineModalFilterService = inject(TimelineModalFilterService);

  @Input() disabled!: boolean | null;

  async qualifiedWorkingTimeStaffChanged() {
    this.timelineModalFilterService.qualifiedWorkingTimeStaffChanged(false);
    this.cdRef.detectChanges();
  }
}
